import script from "./AppPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPage.vue?vue&type=script&setup=true&lang=js"

import "./AppPage.vue?vue&type=style&index=0&id=bcf647ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcf647ce"]])

export default __exports__